const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const updateMyAccountApi = async (userData) => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('[updateMyAccountApi] Ошибка: Токен авторизации не найден.');
    // throw new Error('Токен авторизации не найден.'); 
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/my-account`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[updateMyAccountApi] Ошибка обновления данных моего аккаунта:', errorData);
      throw { ...errorData, statusCode: response.status };
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[updateMyAccountApi] Ошибка сети или другая ошибка при обновлении данных моего аккаунта:', error);
    throw error;
  }
};